import { z } from 'zod';

import { RouterContext } from '~/types/router.type';

import { fetchDeliveryNote } from '~/data/deliveryNote';

export const validateSearch = z.object({
  source: z.string().optional(),
});

export async function getDeliveryNote({
  context,
  params,
}: {
  context: RouterContext;
  params: { deliveryId: string };
}) {
  const { deliveryId } = params;
  const { queryClient } = context;

  //TODO: this should be replaced with ensureQueryData, otherwise additional request is made

  const data = await queryClient.fetchQuery({
    queryKey: ['meta', deliveryId],
    queryFn: async () => fetchDeliveryNote(deliveryId),
  });

  return {
    ...context,
    pageData: {
      title: data.assetState.body.header.id,
    },
  };
}
